module.exports = __webpack_public_path__ + "static/media/teygja_bakaefing_a.030dcadc.png";